import React from 'react';
import { createIcon } from '@chakra-ui/icons';

const CreditCard = createIcon({
  displayName: 'CreditCardIcon',
  viewBox: '0 0 21 18',
  path: (
    <path
      d="M2 14V6V6.325V2V14ZM2 4H18V2H2V4ZM9.675 16H2C1.45 16 0.979333 15.8043 0.588 15.413C0.196667 15.0217 0.000666667 14.5507 0 14V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196666 1.45067 0.000666667 2 0H18C18.55 0 19.021 0.196 19.413 0.588C19.805 0.98 20.0007 1.45067 20 2V7.25C19.4 6.83333 18.75 6.521 18.05 6.313C17.35 6.105 16.6333 6.00067 15.9 6C15 6 14.1333 6.175 13.3 6.525C12.4667 6.875 11.7333 7.36667 11.1 8H2V14H9.075C9.125 14.35 9.2 14.6917 9.3 15.025C9.4 15.3583 9.525 15.6833 9.675 16ZM17.675 15.375L18.375 14.675L16.5 12.8V10H15.5V13.2L17.675 15.375ZM16.025 18C14.625 18 13.4377 17.5167 12.463 16.55C11.4883 15.5833 11.0007 14.4 11 13C10.9993 11.6 11.487 10.4167 12.463 9.45C13.439 8.48333 14.6263 8 16.025 8C17.4083 8 18.5833 8.48767 19.55 9.463C20.5167 10.4383 21 11.6173 21 13C21 14.3827 20.5167 15.562 19.55 16.538C18.5833 17.514 17.4083 18.0013 16.025 18Z"
      fill="currentColor"
    />
  ),
});

export default CreditCard;
